/**
 * The answer key of a fifteen puzzle is a sequence of slides. Kept apart from the form
 * component so the eagerly loaded module file never pulls the author's tray into the player
 * bundle.
 */
import { playable } from "./progress";
import { replay } from "./tray";
import type { FifteenDefinition, FifteenSolution } from "./types";

/** Nothing played yet: an empty key, which `validate_solution` refuses on save. */
export function emptySolution(_definition: FifteenDefinition): FifteenSolution {
  return { moves: "" };
}

/** Whether a stored value is a sequence of slides at all. */
export function isSlideLog(value: unknown): value is FifteenSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const moves = (value as { moves?: unknown }).moves;
  return typeof moves === "string" && /^[udlr]*$/.test(moves);
}

/** Reads whatever is stored, however wrong, as the slides this tray can play. */
export function movesOf(value: unknown, definition: FifteenDefinition): string {
  if (!isSlideLog(value) || !playable(definition)) return "";
  return replay(definition.tiles, definition.size, value.moves).moves;
}
